import React, { Component } from 'react';
import { connect } from 'react-redux';
import QRCode from "react-qr-code";
// import Header from "../components/container/layout/client/Header";
import BusinessHeader from "../components/container/layout/business/Header";
import BusinessUserHeader from "../components/container/layout/business_user/Header";
// import BusinessUserSideBar from "../components/container/SideBar";
// import ClientSideBar from "../components/container/layout/client/SideBar";
// import FooterSection from "../components/UI/FooterSection";
import Footerad from '../components/UI/Footerad';
import axios from "axios";
import { CONFIG } from "../config/data";

import { getTimeoutbycategory } from "../config/url.json";
import IdleTimer from 'react-idle-timer';
import { IdleTimeOutModal } from '../components/container/modal/IdleModal';
import Headerweb from './Headerweb';
import FooterWeb from './Footerweb';
import Topmove from './Topmove';
import { Helmet } from 'react-helmet';
// import ProfileImage3 from './assets/images/profile3.png';
// import myProfilePic from '../../../assets/images/profile3.png'; 

function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch({ type: "SET_LOGOUT" }),
    };
}


class ProductFeatures extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = React.createRef()
        const hospitaltimeout = this.state;
        this.state = {
            timeout: hospitaltimeout,
            isTimedOut: false,
            showModal: false,
        }
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)

    };
    handleClose() {
        this.setState({ showModal: false })
    }


    handleLogout = (e) => {
        this.setState({ showModal: false })
        e.preventDefault();
        localStorage.removeItem("token");
        this.props.logout();

    };

    _onAction(e) {
        console.log('user did something', e)

        this.setState({ isTimedOut: false })
    }

    _onActive(e) {

        console.log('user is active', e)
        this.setState({ isTimedOut: false })
    }

    _onIdle = (e) => {
        console.log('user is idle', e)
        let isTimedOut = this.state.isTimedOut
        let timeout = this.state.timeout;
        console.log(timeout);
        console.log(isTimedOut);
        if (isTimedOut===false) 
        {
         // console.log("the time is over");
          this.setState({showModal: true})
          console.log(this.state.showModal);
           this.idleTimer.reset();
           this.setState({isTimedOut: true})
    
        } 
       if(isTimedOut===true)
       {
        localStorage.removeItem("token");
        this.props.logout();
      }
    }

    render() {
        const { hospitaltimeout } = this.state;
        return (
            <div className="">
                <Helmet>
                    <title>Product Features | KlinicQ </title>
                    <meta 
                        name="description" 
                        content="Explore KlinicQ product features including smart billing, EMR, and tele-consultation. Discover how our integrated tools can transform your medical practice today." 
                    />
                </Helmet>

                <div className="">
                    {/* <section className="my-head"> */}
                        {/* <div className="container-fluid">
                            {this.props.userdata.user_type.toLowerCase() === "hospital" ? (
                                <BusinessHeader user_id={this.props.userdata.id} />
                            ) : this.props.userdata.user_type.toLowerCase() === "doctor" ? (
                                <BusinessUserHeader user_id={this.props.userdata.id} />
                            ) : (
                                <Header user_id={this.props.userdata.id} />
                            )}
                        </div> */}
                    {/* </section> */}
                    <div className="">
                        {/* <div className="sidemenu ">
                            {this.props.userdata.user_type.toLowerCase() === "hospital" ? (
                                <BusinessUserSideBar />
                            ) : this.props.userdata.user_type.toLowerCase() === "doctor" ? (
                                <BusinessUserSideBar />
                            ) : (
                                <ClientSideBar />
                            )}
                        </div> */}

                        {/* <section className="main-body hospital-profilegap "> */}
                            {/* <IdleTimeOutModal
                                showModal={this.state.showModal}
                                handleClose={this.handleClose}
                                handleLogout={this.handleLogout}
                            /> */}

                            {/* <IdleTimer
                                ref={ref => { this.idleTimer = ref }}
                                element={document}
                                onActive={this.onActive}
                                onIdle={this.onIdle}
                                onAction={this.onAction}
                                debounce={250}
                                timeout={hospitaltimeout} /> */}

                            {/* <div className="container-fluid checkout-tabs"> */}
                                {/* <IdleTimeOutModal
                                    showModal={this.state.showModal}
                                    handleClose={this.handleClose}
                                    handleLogout={this.handleLogout}
                                /> */}

                                {/* <IdleTimer
                                    ref={ref => { this.idleTimer = ref }}
                                    element={document}
                                    onActive={this.onActive}
                                    onIdle={this.onIdle}
                                    onAction={this.onAction}
                                    debounce={250}
                                    timeout={hospitaltimeout} /> */}

<div className='product-section'>
    <Headerweb/>
     
    {/* <div className='sub-banner text-center'>
                <h1>Product</h1>
                <p>A Clinical Management System (CMS) is a software solution designed to streamline and enhance the administrative and clinical functions within healthcare facilities. It plays a crucial role in managing patient information, improving efficiency, ensuring regulatory compliance, and enhancing overall patient care. Here are some key components and features typically found in a Clinical Management System</p>
            </div> */}
            {/* <hr className='m-0' style={{ color: '#D9F4FF' }} /> */}
            <div class="desktop-wrapper">
             <div class="desktop">
 <div class="overlap-wrapper1">
        <div class="overlap">
          {/* <div class="background-elements">
            <div class="rectangle"></div>
            <div class="ellipse"></div>
            <div class="ellipse-alt"></div>
            <div class="ellipse-2"></div>
          </div> */}
          <img class="group" src={require("../../src/assets/images/website/benifits bg.png")} alt="Background pattern" />
          <div class="content-section">
            <h1 class="">
             Nucleo Software Solution Empowering Healthcare Through Innovative Technology
            </h1>
            <div class="highlight-box">
              <div class="rectangle-2"></div>
              <p class="highlight-text">
                 In the rapidly evolving landscape of life sciences and healthcare, 
            Nucleo Software Solutions stands as your trusted partner, delivering 
            unparalleled business consulting and Information Technology services.
              </p>
            </div>
            
            
          </div>
          <div class="doctor-image-wrapper">
            <div class="doctor-background"></div>
            <img
              class="doctor-image"
              src={require("../../src/assets/images/website/about doctor.png")}
              alt="Smiling female doctor"
            />
          </div> 
         
          <div class="info-card">
            <img
              class="info-card-image"
              src={require("../../src/assets/images/website/about Rectangle.png")}
              alt="Medical equipment"
            />
            <h2 class="info-card-title">Best Medical</h2>
            <p class="info-card-text">Rapidiously reinvent long-term impact collaboration</p>
          </div>
           <img class="union" src={require("../../src/assets/images/website/Union.png")} alt="Decorative shape" />
          <div class="contact-info">
            <img
              class="contact-icon"
              src={require("../../src/assets/images/website/Union img.png")}
              alt="Contact icon"
            />
            <p class="contact-label">Have a Question?</p>
            <p class="contact-email">info@klinicq.com</p>
          </div>
          <img
            class="decorative-group"
            src={require("../../src/assets/images/website/about star.png")}
            alt="Decorative element"
          />
          <img
            class="decorative-frame"
            src={require("../../src/assets/images/website/about startL.png")}
            alt="Decorative frame"
          />
        
          {/* <div class="decorative-ellipse"></div> */}
           {/* <img
            class="decorative-line"
            src={require("../../src/assets/images/website/about arrow.png")}
            alt="Decorative line"
          /> */}
          {/* <img
            class="decorative-line-2"
            src={require("../../src/assets/images/website/about arrow.png")}
            alt="Decorative line"
          /> */}
        </div>
      </div>
      </div>
             {/* <div class="">
        
       <section class="hero-wrapper">
    <div class="hero-bg-container"></div>

    <div class="hero-content-wrapper">
        <div class="text-section">
            <h1>KlinicQ is a renowned clinic providing exemplary online medical treatment services.</h1>
            <p>Leading clinic offering exceptional online medical treatment services,<br /> ensuring convenient and expert care from the comfort of home.</p>
            
            <div class="review-card">
                <div class="review-avatars">
                     <img src={require("../../src/assets/images/website/img_ellipse_306.png")} alt="Customer avatar" class="avatar" />
                    <img src={require("../../src/assets/images/website/img_ellipse_306.png")} alt="Customer avatar" class="avatar" />
                    <img src={require("../../src/assets/images/website/img_ellipse_305.png")} alt="Customer avatar" class="avatar" />
                    <img src={require("../../src/assets/images/website/img_ellipse_304.png")} alt="Customer avatar" class="avatar" />
                </div>
                <div class="review-divider"></div>
                <img src={require("../../src/assets/images/website/img_32403354493a0fe7fe362882ff282f54_1.png")} alt="Google" class="google-icon" />
                <div class="review-content">
                    <div class="review-title">Take Our Support</div>
                   <img src={require("../../src/assets/images/website/img_group_8751.svg")} alt="5 star rating" class="testimonial-stars" />
                </div>
            </div>
        </div>

        <div class="image-container">
            <img src={require("../../src/assets/images/website/img_smilingfemaledoctorstandingcrossinghandsonevolorbackground_1.png")} alt="Smiling female doctor" class="doctor-image" />
        </div>
    </div>
</section> */}

        <div class="container-90">
            
            <div class="feature-item">
                <div class="feature-image-container">
                    {/* <img src={require("../../src/assets/images/website/img_subtract.svg")} alt="Background shape" class="feature-bg-shape" />
                    <div class="feature-bg-rect"></div> */}
                    <img src={require("../../src/assets/images/website/product emr.jpg")} alt="Electronic Medical Records interface" class="feature-image" />
                </div>
                <div class="feature-content">
                    <h1 class="text-center">Electronic Medical Records ( EMR )</h1>
                    <p class="feature-description">The KlinicQ application maintains the patient's medical records, which include the health history, lab records, discharge summary, prescription details, vitals.</p>
                    <p class="feature-description">KlinicQ application software security is a role-based access configuration for doctors, hospitals, and patients.</p>
                    <p class="feature-description">Patient discharge summary generated based on check-out after treatment, including the visit's reason, diagnosis information, vitals, and prescription details.</p>
                    <p class="feature-description">The data is stored in the cloud so that the ability to transfer the patient data from one clinic/department to the next will be quick.</p>
                    <p class="feature-description">The KlinicQ application is customizable & scalable depending on the data volume to store the electronic medical records that can grow with your practice.</p>
                    <p class="feature-description">Improve the operational efficiency and reduce the documentation searching time, maintain paper records & also the space-saving of a digital record environment</p>
                </div>
                {/* <div class="feature-number right">
                    <span class="feature-number-text">01</span>
                </div> */}
            </div>

            
            <div class="feature-item">
                <div class="feature-image-container">
                    {/* <img src={require("../../src/assets/images/website/img_subtract_white_a700.svg")} alt="Background shape" class="feature-bg-shape" /> */}
                    <img src={require("../../src/assets/images/website/product integrated.jpg")} alt="Integrated solution interface" class="feature-image" />
                </div>
                <div class="feature-content left">
                    <h1 class="text-center">Integrated Solution</h1>
                    <p class="feature-description">All medical records—diagnoses, prescriptions, lab results—are stored in one place, ensuring seamless access for doctors, nurses, and patients across departments or facilities.</p>
                    <p class="feature-description">The solution connects with EHRs, pharmacy systems, labs, and insurance platforms using standards like HL7 or FHIR, enabling real-time data exchange and reducing manual entry.</p>
                    <p class="feature-description">Video consultations, wearable device integration, and home monitoring tools are embedded, allowing proactive care for chronic conditions and remote patients.</p>
                    <p class="feature-description">Tasks like appointment scheduling, referrals, and follow-ups are automated, improving efficiency and ensuring patients don’t fall through the cracks.</p>
                    <p class="feature-description">Dashboards track key metrics like readmission rates, medication adherence, and patient satisfaction—supporting data-driven decisions and value-based care.</p>
                    <p class="feature-description">The platform is cloud-based, mobile-friendly, and compliant with data privacy laws (like HIPAA or India’s DISHA), ensuring secure access for both providers and patients.</p>
                </div>
                {/* <div class="feature-number left">
                    <span class="feature-number-text">02</span>
                </div> */}
            </div>

            
            <div class="feature-item ">
                <div class="feature-image-container">
                    {/* <img src={require("../../src/assets/images/website/img_subtract.svg")} alt="Background shape" class="feature-bg-shape" />
                    <div class="feature-bg-rect"></div> */}
                    <img src={require("../../src/assets/images/website/product expensive.jpg")} alt="No expensive hardware" class="feature-image" />
                </div>
                <div class="feature-content">
                    <h1 class="text-center">No expensive Hardware</h1>
                    <p class="feature-description">The entire system runs on secure cloud servers, eliminating the need for on-premise servers, data centers, or high-maintenance IT hardware.</p>
                    <p class="feature-description">Doctors, nurses, and patients can access the platform from any smartphone, tablet, or basic laptop—no need for specialized terminals or kiosks.</p>
                    <p class="feature-description">The solution supports API-based connections with labs, pharmacies, and diagnostic tools, avoiding the need for proprietary hardware or custom-built bridges.</p>
                    <p class="feature-description">KlinicQ with responsive web apps and mobile apps, the system works seamlessly on low-cost Android or iOS devices, making it accessible in rural or resource-limited settings.</p>
                    <p class="feature-description">Instead of expensive hospital-grade monitors, the platform can integrate with affordable wearables (like smartwatches or Bluetooth BP monitors) for real-time vitals tracking.</p>
                    <p class="feature-description">No need for IT teams to install or maintain physical infrastructure—updates, backups, and security patches are handled remotely by the provider.</p>
                </div>
                {/* <div class="feature-number right">
                    <span class="feature-number-text">03</span>
                </div> */}
            </div>

           
            <div class="feature-item">
                <div class="feature-image-container">
                    {/* <img src={require("../../src/assets/images/website/img_subtract_white_a700.svg")} alt="Background shape" class="feature-bg-shape" /> */}
                    <img src={require("../../src/assets/images/website/img_image_466x445.png")} alt="Integrated solution interface" class="feature-image" />
                </div>
                <div class="feature-content left">
                    <h1 class="text-center">Modular & Scalable Architecture</h1>
                    <p class="feature-description">Each module handles a specific responsibility—like EMR, billing, or telehealth—making the system easier to develop, test, and maintain independently.</p>
                    <p class="feature-description">New features (e.g., pharmacy integration or analytics dashboards) can be added or removed without disrupting the core system, enabling faster innovation and customization.</p>
                    <p class="feature-description">Modules can scale individually based on demand. For example, if teleconsultations spike, only that service needs more resources—saving cost and improving performance.</p>
                    <p class="feature-description">Modules communicate through well-defined APIs or service contracts, reducing dependencies and allowing teams to work in parallel without breaking the system.</p>
                    <p class="feature-description">Since modules are isolated, updates or bug fixes can be deployed to one part of the system without requiring a full system redeploy—minimizing downtime.</p>
                    <p class="feature-description">You can upgrade or replace individual modules (e.g., switch from one payment gateway to another) without rewriting the entire platform—ensuring long-term flexibility.</p>
                </div>
                {/* <div class="feature-number left">
                    <span class="feature-number-text">02</span>
                </div> */}
            </div>

            
            <div class="feature-item">
                <div class="feature-image-container">
                    {/* <img src={require("../../src/assets/images/website/img_subtract.svg")} alt="Background shape" class="feature-bg-shape" />
                    <div class="feature-bg-rect"></div> */}
                    <img src={require("../../src/assets/images/website/img_image_1.png")} alt="No expensive hardware" class="feature-image" />
                </div>
                <div class="feature-content">
                    <h1 class="text-center">Offline Access & Auto-Sync</h1>
                    <p class="feature-description">Users can access patient records, forms, and essential data even without internet connectivity—ideal for rural clinics, mobile health units, or emergency response teams.</p>
                    <p class="feature-description">Once the device reconnects to the internet, all offline updates (like new entries, edits, or uploads) are automatically synced to the cloud—no manual intervention needed.</p>
                    <p class="feature-description">If multiple users edit the same record offline, the system detects conflicts and prompts for resolution or merges changes intelligently to maintain data integrity.</p>
                    <p class="feature-description">Only relevant data (e.g., assigned patients or scheduled appointments) is downloaded to the device, optimizing performance All offline data is encrypted and stored securely on the device, ensuring compliance with privacy regulations like HIPAA or DISHA.</p>
                    <p class="feature-description">Visual cues (like sync status icons or timestamps) inform users when data is pending, syncing, or successfully updated—boosting confidence and transparency.</p>
                </div>
                {/* <div class="feature-number right">
                    <span class="feature-number-text">03</span>
                </div> */}
            </div>

           
            {/* <div class="feature-item">
                <div class="feature-image-container"> */}
                    {/* <img src={require("../../src/assets/images/website/img_subtract.svg")} alt="Background shape" class="feature-bg-shape" />
                    <div class="feature-bg-rect"></div> */}
                    {/* <img src={require("../../src/assets/images/website/img_image.png")} alt="Electronic Medical Records interface" class="feature-image" />
                </div>
                <div class="feature-content">
                    <h2 class="feature-title">Electronic Medical Records ( EMR )</h2>
                    <p class="feature-description">The KlinicQ application maintains the patient's medical records, which include the health history, lab records, discharge summary, prescription details, vitals.</p>
                    <p class="feature-description">KlinicQ application software security is a role-based access configuration for doctors, hospitals, and patients.</p>
                    <p class="feature-description">Patient discharge summary generated based on check-out after treatment, including the visit's reason, diagnosis information, vitals, and prescription details.</p>
                    <p class="feature-description">The data is stored in the cloud so that the ability to transfer the patient data from one clinic/department to the next will be quick.</p>
                    <p class="feature-description">The KlinicQ application is customizable & scalable depending on the data volume to store the electronic medical records that can grow with your practice.</p>
                    <p class="feature-description">Improve the operational efficiency and reduce the documentation searching time, maintain paper records & also the space-saving of a digital record environment</p>
                </div>
                <div class="feature-number right">
                    <span class="feature-number-text">01</span>
                </div>
            </div> */}
        </div>
    </div>
    
            {/* <section className='py-5'>
            <div className='container-90' id='increase_revenue' style={{ marginTop: '50px' }}>
    <div className='row m-0 align-items-center'>
    <div className='col-lg-6 col-12 slide-left visible'>
    <h1>Product Feature</h1>
    <div className='find-doctor text-center py-3'>
      <a href="/listofservice" style={{ textDecoration: 'none' }}>
        <button>
          List of service
          <img src={require("../../src/assets/images/website/arrowup.png")} className='ml-2' alt="Arrow Up" />
        </button>
      </a>
    </div>
</div>
        <div className='col-lg-6 col-12'>
            <p>A Clinical Management System (CMS) is a software solution designed to streamline and enhance the administrative and clinical functions within healthcare facilities. It plays a crucial role in managing patient information, improving efficiency, ensuring regulatory compliance, and enhancing overall patient care. Here are some key components and features typically found in a Clinical Management System</p>
        </div>
    </div>
</div>
<div className=''>
                <div className='' id='increase_productivity' style={{ marginTop: '50px', marginBottom: '50px' }}>
    <div className='row m-0'>
        <div className='col-12'>
            <img src={require("../../src/assets/images/website/ProductFeature1.png")} className='w-100 h-auto' alt="Increase Productivity" />
        </div>
    </div>
</div>
</div>
                <div className='container-90'>
                    <div className='row m-0'>
                        <div className='col-lg-6 col-12 text-center slide-left visible'>
                            <img src={require("../../src/assets/images/website/ProductFeature2.png")} className='w-75 ml-5 d-lg-block d-none' />
                        </div>
                        <div className='col-lg-6 mt-5 slide-right visible'>
                            <h3>Electronic Medical Records ( EMR )</h3> */}
                            {/* <div className='img-responsive'>
                                <img src={require("../../src/assets/images/website/ProductFeature2.png")} className='ml-5 d-lg-none d-block' />
                            </div> */}
                            {/* <p>The KlinicQ application maintains the patient's medical records, which include the health history, lab records, discharge summary, prescription details, vitals.</p>
                            <p>KlinicQ application software security is a role-based access configuration for doctors, hospitals, and patients.</p>
                            <p>Patient discharge summary generated based on check-out after treatment, including the visit's reason, diagnosis information, vitals, and prescription details.</p>
                            <p>The data is stored in the cloud so that the ability to transfer the patient data from one clinic/department to the next will be quick.</p>
                            <p>The KlinicQ application is customizable & scalable depending on the data volume to store the electronic medical records that can grow with your practice.</p>
                            <p>Improve the operational efficiency and reduce the documentation searching time, maintain paper records & also the space-saving of a digital record environment</p>
                        </div>
                    </div>
                </div>
                <div className='bg-section'>
                    <div className='container-90' id='integrated_solution'>
                        <div className='row m-0 flex-wrap-reverse' >
                            <div className='col-lg-6 col-12 mt-5 pt-lg-5 mt-5 slide-left visible'>
                                <h3>Integrated Solution</h3>
                                <div className='img-responsive'>
                                    <img src={require("../../src/assets/images/website/ProductFeature3.png")} className=' ml-5 d-lg-none d-block' />
                                </div>
                                <p>KlinicQ application accounts management function developed with GST function and invoicing for medical services and supplies.</p>
                                <p>KlinicQ application is integrated with Razor payment way for digital payments.</p>
                                <p>The KlinicQ application is integrated with Twilio for Video calling between doctors and patients.</p>
                                <p>KlinicQ application integrates with Google Maps for wait time and travel time display.</p>
                                <p>KlinicQ application APIs can integrate with any existing portals to update the details from KlinicQ and extract the information as per the security guidelines, so there is no need to replace the existing system.</p>
                                <p>KlinicQ application is fully integrated between Doctors, Hospitals and patients and no need to duplicate the records </p>
                            </div>
                            <div className='col-lg-6 col-12 text-center slide-right visible'>
                                <img src={require("../../src/assets/images/website/ProductFeature3.png")} className=' ml-5 d-lg-block d-none' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='container-90 pt-5'>
                    <div className='row m-0' id='no_expensive_hardware'>
                        <div className='col-lg-6 col-12 text-center slide-left visible'>
                            <img src={require("../../src/assets/images/website/ProductFeature4.png")} className='w-75 ml-5 d-lg-block d-none' />
                        </div>
                        <div className='col-lg-6 col-12 mt-5 pt-lg-5 slide-right visible'>
                            <h1>No expensive Hardware</h1>
                            <div className='img-responsive'>
                                <img src={require("../../src/assets/images/website/ProductFeature4.png")} className='w-75 ml-5 d-lg-none d-block' />
                            </div>
                            <p>The KlinicQ application is a cloud-based solution (AWS - amazon web services), and all the data is stored in the cloud server so that no additional server setup is required, network & expensive hardware is required at your Clinic.</p>
                            <p>KlinicQ Clinical Management System runs in Android & IOS mobile applications and can be downloaded from the Google Play Store and Apple App Store. Works with any cell phones or tablets with Wi-Fi Hotspots & no wires or software installation is required.</p>
                            <p>KlinicQ application can be accessed through any web browser of any device (Google Chrome, Safari, Microsoft Edge, etc.) so no need have special software</p>
                        </div>
                    </div>
                </div>
                <div className='bg-section' >
                    <div className='container-90' id="easy_communication" >
                        <div className='row m-0 flex-wrap-reverse'>
                            <div className='col-lg-6 col-12 mt-150 slide-left visible'>
                                <h1>Easy Communication</h1>
                                <div className='img-responsive'>
                                    <img src={require("../../src/assets/images/website/ProductFeature5.png")} className='w-75 ml-5 d-lg-none d-block' />
                                </div>
                                <p>KlinicQ system is an interactive appointment scheduling software that offers bi-directional communication, connecting hospital doctors with patients.</p>
                                <p>KlinicQ clinical management system sends notification and appointment status updates through SMS text messages.</p>
                                <p>The KlinicQ application helps to set a reminder of critical appointment reminders for physicians, and automated reminders to patients on follow-up days will be sent through emails, including appointment details, promotional messages, and Health instructions for patient convenience.</p>
                            </div>
                            <div className='col-lg-6 col-12 text-center slide-right visible'>
                                <img src={require("../../src/assets/images/website/ProductFeature5.png")} className='w-75 ml-5 d-lg-block d-none' />
                            </div>
                        </div>
                    </div>

                </div>

                <div className='container-90' id='user_friendly'>
               
                    <div className='row m-0 pt-5' >
                        <div className='col-lg-6 col-12 text-center slide-left visible'>
                            <img src={require("../../src/assets/images/website/ProductFeature6.png")} className='w-75 ml-5' />
                        </div>
                        <div className='col-lg-6 col-12 mt-lg-0 slide-right visible'>
                        <h1 >User Friendly Application</h1>
                            <p>The KlinicQ application can be accessed anywhere and anytime to view their consultation summary, vital details, health records and prescription details for up to 2 years from the day they start using the KlinicQ app.</p>
                            <p>The KlinicQ application calculates and provides BMI based on the vital details measured during check-in. Height, blood pressure, pulse, and weight are measured and can be viewed at any time.</p>
                            <p>The monitor connected to the Kiosk will display the queue list and status of each appointment, making it easier for the patients to check their turn.Traceability is easier with the KlinicQ application, as every visit has a unique appointment ID.</p>
                            <p>Patient’s appointment and token status are effortlessly notified when it is their turn through the mobile app, making the patients engage at every stage. Appointment status is displayed on TV in the waiting room.</p>
                            <p>The monitor connected to the Kiosk will display the queue list and status of each appointment, making it easier for the patients to check their turn.</p> */}
                            {/* <p>Android and IOS mobile Apps are available for Patient, Doctor & Hospital modules with multi-language compatibility & supports English, Tamil, Kannada, Telugu & Hindi.</p>
                            <p>The KlinicQ app is an easy-to-use, automated, integrated solution between patients, physicians, and Hospitals. The KlinicQ application informs patients about their queue status & gives them peace of mind.</p> */}
                        {/* </div>
                    </div>
                </div>
                <div className='bg-section' >
                    <div className='container-90' id="easy_communication" >
                        <div className='row m-0 flex-wrap-reverse'>
                            <div className='col-lg-6 col-12 mt-150 slide-left visible'>
                                <h1>Resource planning & Scheduling</h1>
                                <div className='img-responsive'>
                                    <img src={require("../../src/assets/images/website/ProductFeature8.png")} className='w-75 ml-5 d-lg-none d-block' />
                                </div>
                                <p>The KlinicQ application's scheduling function helps to do resource planning and to manage hospitals/clinic and doctor's schedules effectively by day, week, and month to avoid overlapping & overbooking.</p>
                                <p>The KlinicQ application's appointment scheduling function helps to schedule for doctors based on their availability automatically.</p>
                            </div>
                            <div className='col-lg-6 col-12 text-center slide-right visible'>
                                <img src={require("../../src/assets/images/website/ProductFeature8.png")} className='w-75 ml-5 d-lg-block d-none' />
                            </div>
                        </div>
                    </div>

                </div>
                <div className='container-90' id='user_friendly'>
               
               <div className='row m-0 pt-5 align-items-center' >
                   <div className='col-lg-6 col-12 text-center slide-left visible'>
                       <img src={require("../../src/assets/images/website/ProductFeature9.png")} className='w-75 ml-5' />
                   </div>
                   <div className='col-lg-6 col-12 mt-lg-0 mt-5 slide-right visible'>
                   <h1 >
                   Billing & Payments</h1>
                       <p>KlinicQ application supports patient billing, invoices of all consultancy services with details of Patient Information, Services provided like Room rent, Clinical supplies, Consultation, Nursing Charges, Laboratory tests, X-rays, Ultrasound, Medicines, procedures, and the tax percentage calculated based on the relevant services</p>
                       <p>The payment gateway service is integrated with KlinicQ, simplifying the customer payment process.</p>
                   </div>
               </div>
           </div>
           <div className='bg-section' >
                    <div className='container-90' id="easy_communication" >
                        <div className='row m-0 flex-wrap-reverse'>
                            <div className='col-lg-6 col-12 mt-150 slide-left visible'>
                                <h1>Data Analytics & KPI Reports</h1>
                                <div className='img-responsive'>
                                    <img src={require("../../src/assets/images/website/ProductFeature10.png")} className='w-75 ml-5 d-lg-none d-block' />
                                </div>
                                <p>KlinicQ application's analytical insights are incredibly effective and can be used to grow your business.</p>
                                <p>Our Clinical Management System has been designed with various KPI reports and trends based on average waiting times, consulting time, clinical records, pharmacy & laboratory records, etc., to do analysis and improve it.</p>
                                <p>KlinicQ applications analyze the real-time data of Patient visit trends based on locations, and these analytics insights features provide customers with habits who aren't showing up and who are returning.</p>
                            </div>
                            <div className='col-lg-6 col-12 text-center slide-right visible'>
                                <img src={require("../../src/assets/images/website/ProductFeature10.png")} className='w-75 ml-5 d-lg-block d-none' />
                            </div>
                        </div>
                    </div>

                </div>
                <div className='container-90' id='user_friendly'>
               
               <div className='row m-0 pt-5' >
                   <div className='col-lg-6 col-12 text-center slide-left visible'>
                       <img src={require("../../src/assets/images/website/ProductFeature11.png")} className='w-75 ml-5 ' />
                   </div>
                   <div className='col-lg-6 col-12 mt-5 slide-right visible'>
                   <h1 >
                   Appointment Scheduling</h1>
                      <p>The KlinicQ application supports any of these three types of appointment booking by the token management system, appointment management system, and teleconsultation.</p>
                      <p>The KlinicQ application supports booking an appointment through the online mobile application, phone, and walk-in options for our patients & a teleconsultation appointment (Video calling) option available for patients unable to visit the hospital.</p>
                      <p>The KlinicQ application allows to manage emergency appointments & grace period functions, which helps to adjust the appointment schedule automatically for patients who arrive late to the hospital.</p>
                      <p>The KlinicQ application supports quick and effective inpatient and outpatient appointment scheduling and automatically sends text and email reminders.</p>
                   </div>
               </div>
           </div>
           <div className='bg-section' >
                    <div className='container-90' id="easy_communication" >
                        <div className='row m-0 flex-wrap-reverse'>
                            <div className='col-lg-6 col-12 mt-50 slide-left visible'>
                                <h1>Kiosk integration capability</h1>
                                <div className='img-responsive'>
                                    <img src={require("../../src/assets/images/website/ProductFeature12.png")} className='w-75 ml-5 d-lg-none d-block' />
                                </div>
                                <p class="text-justify">

Kiosks in the hospital waiting room allow customers to add themselves to a queue without staff assistance. On the touchscreen, patients can enter their phone number or scan the QR code to retrieve their appointment and the monitor connected to the Kiosk will display each appointment's queue list and status.</p>
<p class="text-justify">Patient's vital details can be measured at the Kiosk system. The vital blood pressure, pulse, height, weight, and BMI details can be automatically transferred to the KlinicQ app for the appointment visit. </p>
                            </div>
                            <div className='col-lg-6 col-12 text-center slide-right visible'>
                                <img src={require("../../src/assets/images/website/ProductFeature12.png")} className='w-75 ml-5 d-lg-block d-none' />
                            </div>
                        </div>
                    </div>

                </div>
                <div className='container-90' id='user_friendly'>
               
               <div className='row m-0 pt-5 align-items-center' >
                   <div className='col-lg-6 col-12 justify-content-center slide-left visible'>
                       <img src={require("../../src/assets/images/website/ProductFeature7.png")} className='w-75' />
                   </div>
                   <div className='col-lg-6 col-12 mt-50 slide-right visible'>
                   <h1 >Privacy & Security</h1>
                   <p class="text-justify">KlinicQ application is designed per HIPAA (Health Insurance Portability and Accountability Act) rules. Personal identification information (PII) and protected health information (PHI) records are securely encrypted &amp; are safe and not for sale to any third parties.

</p>
<p class="text-justify">KlinicQ Clinical Management System role-based security is assigned to the doctors, hospitals, and patients to provide relevant authorization to control access. Privacy &amp; security are our number one priority, and we ensure that no selling of personal data.</p>
                   </div>
               </div>
           </div>
            </section> */}

                                {/* <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="font-weight-bold">QR Code</h4>
                                    </div> */}


                                {/* </div> */}

                                {/* <div className="card pt-4">
                                    <div className="card-body">
                                        <div className="tab-content text-center" id="v-pills-tabContent">
                                            <h5 className="hedtxt2 ">Open the built-in camera app and point the camera at the QR Code Scanner for Check-in purposes.</h5>

                                            <div
                                                className="tab-pane fade show active qrcode pd-15"
                                                id="v-pills-shipping"
                                                role="tabpanel"
                                                aria-labelledby="v-pills-shipping-tab"

                                            >


                                                <QRCode value={this.props.userdata.phone_number} />
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                {/* <Footerad /> */}
                            {/* </div>
                          
                        </section> */}
                        <Topmove />
                        <FooterWeb className="qrCodeFooter" />
                    </div>
                    </div>
                </div>
            </div>
        );
    }
    componentDidMount = () => {
     /*    console.log(this.props.userdata.user_type);
        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${this.props.access_token}`;

        axios
            .post(getTimeoutbycategory, { category: this.props.userdata.user_type }, CONFIG)
            .then((res) => {
                let data = res.data;
                console.log(res);
                console.log(data);
                console.log(data.data.timeout);
                if (data.status === "1")
                    this.setState({
                        hospitaltimeout: data.data.timeout

                    });
            })
            .catch((e) => { }); */
    }
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(ProductFeatures);